import { type DomainAccessControlConfig } from '../utils/domain/accessControl'
import { Permission } from './permissions'

export const recipeAdminLibraryCsvIngestionAccessConfiguration: DomainAccessControlConfig = {
  permissions: Permission.AdminPanel,
}
